import Swal from 'sweetalert2';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  
} from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";

import MyAutoComplete from '../../../components/inputs/MyAutoCompleteJavier';
import { useEffect, useState } from 'react';

import { myApi, otherApi } from '../../../config/axiosConfig';

const AssignModal = ({
  open,
  onClose,
  index,
  label,
  setCurrentStepIndex,
  setStepData,
}) => {

  const validationSchema = Yup.object().shape({
      unidad: Yup.string().required("La unidad es obligatoria."),
    });

  const [unidades, setUnidades] = useState([]);

const verificarQRExistente = async () => {
  try {
    const res = await myApi.get(`/alta_unidad/verificarQRAsignado?qr=${label}`);
    
    if (res.data.unidadAsignada) {
      onClose();
      if (res.data.tipoAsignado !== index) 
      {
        await Swal.fire({
          icon: 'error',
          title: 'QR ya asignado a otro tipo',
          html: `Este QR ya fue asignado a la unidad <strong>${res.data.unidadAsignada}</strong> del tipo <strong>${res.data.tipoAsignado.toUpperCase()}</strong>.<br><br>No puedes usarlo para un <strong>${index.toUpperCase()}</strong>.`,
          backdrop: true
        });
        onClose();
        return;
      }

      const result = await Swal.fire({
        icon: 'question',
        title: 'QR ya asignado',
        html: `Este QR ya fue asignado a la unidad <strong>${res.data.unidadAsignada}</strong>.<br><br>¿Deseas continuar el alta con esa unidad?`,
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
        backdrop: true
      });

      if (result.isConfirmed) {
        sessionStorage.setItem('qrPendienteAsignado', label);

        setStepData((prev) => {
          const updated = [...prev];
          updated[0] = {
            ...(updated[0] || {}),
            inputs: {
              ...(updated[0]?.inputs || {}),
              unidadSeleccionada: res.data.unidadAsignada,
            },
          };
          return updated;
        });

        Swal.fire({
          icon: 'info',
          title: 'Unidad asignada cargada',
          text: 'Completa el paso actual para continuar.',
        });
        setCurrentStepIndex((prev) => prev + 1);

        onClose();
      } else {
        onClose();
      }
    }
  } catch (error) {
    console.error("Error al verificar asignación previa del QR:", error);
  }
};

  const findUnidades = async () => 
  {
      setUnidades([]);
      try 
      {
          const response = await otherApi.get(`/fuel_report/getUnidades?tipo=${index}`);

          console.log(response.data.data)

          let unidades = [];
          response.data.data.forEach(unidad => {
            if(index == 'tractor')
              unidades.push({ value: unidad.tractor, label: unidad.tractor });
            else
              unidades.push({ value: unidad.caja, label: unidad.caja });
          });
          setUnidades(unidades);
      } 
      catch (error) 
      {
          console.error('Error fetching units:', error);
      }
  };

  useEffect(() => {
    if (open) {
        verificarQRExistente(); 
        findUnidades();
    }
  }, [index, open]);
 
  return (
    <Dialog open={open} maxWidth="xs">
      <DialogTitle>Asignación del QR # {label}</DialogTitle>
      <Formik
        initialValues={{
          unidad: "",
        }}
        validationSchema={validationSchema}
        //onSubmit={async (formData) => {
        onSubmit={async (formData, { setFieldValue }) => {
          try 
          {
            const unidad = formData.unidad;

            setFieldValue("unidad", unidad);

            const verificacion = await myApi.get(`/alta_unidad/verificarUnidadQR?unidad=${unidad}`);

            onClose();
            if (verificacion.data.qrAsignado && verificacion.data.qrAsignado !== label) 
            {
                const confirmar = await Swal.fire({
                  icon: 'warning',
                  title: `Unidad con QR asignado: ${verificacion.data.qrAsignado}`,
                  text: '¿Deseas reemplazar este QR por el nuevo?',
                  showCancelButton: true,
                  confirmButtonText: 'Sí, reemplazar',
                  cancelButtonText: 'Cancelar',
                  backdrop: true
                });

                if (!confirmar.isConfirmed) {
                  onClose();
                  return;
                }
            }

              const response = await myApi.post("/alta_unidad/insertUnidadQR", {
                idqr: label,
                unidad: formData.unidad,
                tipo: index
              });

              if (response.data.success) 
              {
                sessionStorage.setItem('qrPendienteAsignado', label);

                setStepData((prev) => {
                  const updated = [...prev];
                  updated[0] = {
                    ...(updated[0] || {}),
                    inputs: {
                      ...(updated[0]?.inputs || {}),
                      unidadSeleccionada: formData.unidad,
                    },
                  };
                  return updated;
                });

                setCurrentStepIndex((prev) => prev + 1);

                onClose();

                await Swal.fire({
                  icon: 'success',
                  title: 'Asignación exitosa',
                  text: `Se asignó correctamente la unidad ${formData.unidad} al QR ${label}`,
                  backdrop: true
                });

                
              } 
              else if (response.data.duplicado) 
              {
                const result = await Swal.fire({
                  icon: 'error',
                  title: `QR NO DISPONIBLE: ${label}`,
                  html: `Asignado a unidad: <b>${response.data.asignadoA}</b><br>${new Date(response.data.fecha).toLocaleDateString()}`,
                  confirmButtonText: 'Escanear otro',
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  backdrop: true
                });

                if (result.isConfirmed) 
                {
                  setTimeout(() => {
                    setCurrentStepIndex(0);
                    setStepData([]);
                  }, 300);
                }
                onClose();
              }           
          } 
          catch (error) 
          {
             console.error("Error al insertar:", error);
             onClose();
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un problema al intentar guardar la asignación.',
                backdrop: true
              });
          }
        }}
      >
        {({
          handleSubmit,
          values,
        }) => {
          return (
          <>
            <DialogContent>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1.5,
                      fontWeight: 'bold',
                      color: 'primary.main',
                      textAlign: 'center',
                      textTransform: 'uppercase',
                      letterSpacing: 0.5,
                    }}
                  >
                    ¿Qué unidad desea asignar?
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <MyAutoComplete
                    name="unidad"
                    label="Unidad"
                    options={unidades}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleSubmit}>Asignar</Button>
              <Button onClick={onClose}>Cancelar</Button>
            </DialogActions>
          </>
        )}}
      </Formik>
    </Dialog>
  );
};

export default AssignModal;
